import React from 'react';
import { process } from '../data/content';
export function Process() {
  return <section id="process" className="w-full border-t border-line bg-ink py-24 lg:py-32" data-id="element-139" data-mp="1udd65jw7r4gg">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-140" data-mp="1yf74vmmulydz">
        <p className="display text-sm tracking-widest text-brand-red" data-id="element-141" data-mp="1yfqcoaisb6ea">{process.eyebrow}</p>
        <h2 className="display mt-3 max-w-2xl text-[clamp(2rem,4.4vw,3.25rem)] leading-[0.98] text-cream" data-id="element-142" data-mp="23d0bggs2cues">
          {process.heading}
        </h2>

        <ol className="mt-14 border-t border-line" data-id="element-143" data-mp="1apma86hc1cov">
          {process.steps.map((step, i) => <li key={step.title} className="grid gap-4 border-b border-line py-9 md:grid-cols-[6rem_minmax(0,20rem)_minmax(0,1fr)] md:items-baseline md:gap-10" data-id="element-144" data-mp="1fopgtvcynqyy" data-mpi={i}>
              <span className="display text-4xl leading-none text-brand-red md:text-5xl" data-id="element-145" data-mp="n01rnop3chg4">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="display text-2xl leading-tight text-cream" data-id="element-146" data-mp="rxjwp3zzmciu">{step.title}</h3>
              <p className="max-w-xl text-base leading-relaxed text-cream/70" data-id="element-147" data-mp="19jxxjplndwgr">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}